import { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/nl';

export default function useAvailableMenus(menu, selectedDate, selectedTime) {
  const [availableMenus, setAvailableMenus] = useState([]);

  useEffect(() => {
    moment.locale('nl');

    if (selectedDate && selectedTime && Array.isArray(menu) && menu.length > 0) {
      const selectedDateTime = moment(`${selectedDate} ${selectedTime}`, 'YYYY-MM-DD HH:mm');

      const filtered = menu.filter((menuItem) => {
        // Date range inclusive
        const menuStartDate = moment(menuItem.startDate, 'YYYY-MM-DD');
        const menuEndDate = moment(menuItem.endDate, 'YYYY-MM-DD');
        const isDateInRange = selectedDateTime.isBetween(menuStartDate, menuEndDate, 'day', '[]');

        // Time range inclusive
        const menuStartTime = moment(menuItem.startHour, 'HH:mm');
        const menuEndTime = moment(menuItem.endHour, 'HH:mm');
        const selectedTimeMoment = moment(selectedTime, 'HH:mm');
        const isTimeInRange = selectedTimeMoment.isBetween(menuStartTime, menuEndTime, 'minute', '[]');

        // Day of week match or no restriction
        const selectedDayOfWeek = selectedDateTime.format('dddd').toLowerCase();
        const daysOfWeek = (menuItem.daysOfWeek || []).map((day) => day.toLowerCase());
        const isDayMatching = daysOfWeek.length === 0 || daysOfWeek.includes(selectedDayOfWeek);

        return isDateInRange && isTimeInRange && isDayMatching;
      });

      setAvailableMenus(filtered);
    } else {
      setAvailableMenus([]);
    }
  }, [menu, selectedDate, selectedTime]);

  return availableMenus;
}


